import { IRemoteQueryAgent } from '../../settings/types/ISiteSettingsForSiteAdmin';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Messages } from '../../codegen/Localize';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import {
  ActionDialogBodyWithInlineErrorMessage,
  ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState
} from '../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import {TabDialogWidth} from '../../commonInfra/dialogs/style/TabDialogWidth';
import {openReactActionDialog} from '../../commonInfra/dialogs/ReactActionDialog';
import {ContentActionNotification} from '../../commonInfra/contentActions/ContentActionNotification';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export namespace DeleteRemoteAgentAction {
  export function execute(agent: IRemoteQueryAgent, ownerId: string, context: IActionContext): Promise<IResult> {
    const message = Messages.confirmDeleteRemoteAgent({NAME: L10n.elideIfLong(agent.agentName)});
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: message};
    const dialogInstance = openReactActionDialog({
      title: Messages.deleteMessage(),
      actionName: Messages.deleteMessage(),
      action: (_, state, updateDialogState) => {
        return ServerUsers.instance.deleteUserRemoteAgents(ownerId, [agent.deviceId])
          .then((result: IResult) => {
            if (!result || (result.errors && result.errors.length)) {
              const errorMessage = this.errorMessageFor(result.errors[0]);
              updateDialogState({errorMessage: errorMessage});
            } else {
              ContentActionNotification.displaySuccessToast(Messages.deleteConnectedAgentSuccess());
            }
            return result;
          });
      },
      isActionDelete: true,
      dialogWidth: TabDialogWidth.width375px,
      bodyComponent: ActionDialogBodyWithInlineErrorMessage,
      dismissDialogOnActionFailed: false,
      initialBodyProps,
      initialDialogState
    });

    return Promise.resolve(dialogInstance.result);
  }

  export function errorMessageFor(error: IError) {
    return Messages.errorUnknown();
  }
}


//TODO: Move this file to its own module TFS:1188858
export type DeleteRemoteAgentAction = typeof DeleteRemoteAgentAction;
